import { render, staticRenderFns } from "./smallTable.vue?vue&type=template&id=4a08d1a1&scoped=true&"
import script from "./smallTable.vue?vue&type=script&lang=js&"
export * from "./smallTable.vue?vue&type=script&lang=js&"
import style0 from "./smallTable.vue?vue&type=style&index=0&id=4a08d1a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08d1a1",
  null
  
)

export default component.exports